export const formatCurrency = (amount: number, currency = 'EUR'): string =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(amount);

export const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('de-DE').format(date);
};

export const formatDateTime = (dateString: string): string =>
  new Intl.DateTimeFormat('de-DE', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(dateString));
